/** How far a character's death has shown, from how far through the scene the playhead is. */
export interface DeathMoment {
  grayscale: number;
  opacity: number;
  labelOpacity: number;
}

const clamp01 = (value: number): number => Math.min(1, Math.max(0, value));
const between = (t: number, from: number, to: number): number => clamp01((t - from) / (to - from));

/** Tied to the playhead, so pausing or scrubbing holds it at that moment. */
export function deathMomentAt(t: number): DeathMoment {
  const fade = between(t, 0.1, 0.5);
  return {
    grayscale: fade,
    opacity: 1 - 0.55 * fade,
    labelOpacity: between(t, 0.3, 0.5),
  };
}
